import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import api from "@/lib/api";
import { toast } from "sonner";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const loc = useLocation();
  const nav = useNavigate();
  const { setUser } = useAuth();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const hash = loc.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) {
      nav("/login", { replace: true });
      return;
    }
    const session_id = decodeURIComponent(m[1]);
    (async () => {
      try {
        const { data } = await api.post("/auth/session", { session_id });
        if (data.token) localStorage.setItem("atc_token", data.token);
        setUser(data);
        // clear hash + go to app
        window.history.replaceState({}, "", "/app");
        nav("/app", { replace: true });
        toast.success(`Welcome, ${data.name.split(" ")[0]}.`);
      } catch (e) {
        toast.error("Sign-in failed. Please try again.");
        nav("/login", { replace: true });
      }
    })();
    // eslint-disable-next-line
  }, []);

  return (
    <div className="min-h-screen parchment flex items-center justify-center">
      <div className="text-center">
        <div className="font-serif text-2xl mb-3">Bringing you in…</div>
        <div className="text-sm text-muted-foreground">Verifying your Google sign-in</div>
      </div>
    </div>
  );
}
